export const toUpCase = (str: string) =>
    str?.charAt(0)?.toUpperCase() + str?.slice(1);
